import { useQuery } from 'react-query';

import { getApiVersion } from './queries';

export const useApiVersion = () => useQuery('api', getApiVersion);
